import React from "react";
import ReactDOM from "react-dom";
import Toast from "./Toast";
import "./Toast.css";

const ToastContainer = ({ toasts, removeToast }) => {
    if (toasts.length === 0) return null;

    return ReactDOM.createPortal(
        <div className="ui-toast-container">
            {toasts.map((t) => (
                <Toast
                    key={t.id}
                    id={t.id}
                    type={t.type}
                    message={t.message}
                    duration={t.duration}
                    onDismiss={removeToast}
                />
            ))}
        </div>,
        document.body
    );
};

export default ToastContainer;
